import universalLocalStorage from "../../utils/lib/universalLocalStorage";
import goTo from "../goTo";

export default async function saveUserAuth(data) {
  if (data) {
    await universalLocalStorage.setItem("karuna-token", data.token);
    await universalLocalStorage.setItem("karuna-userId", data.userId);

    window.doInitialLoad().then(() => {
      goTo("/")();
    });
  }
}
